import {
  RELEASE_NOTES_PDF_BY_VERSION,
  RELEASE_NOTES_PDF_VERSIONS,
} from '../../lib/api-routes'
import { HttpResponse, instance } from '../../lib/axiosInstance'

export const getAllReleaseNotes = async (): Promise<HttpResponse> => {
  const response = await instance.get(RELEASE_NOTES_PDF_VERSIONS)
  return response
}

export const getReleaseNotesPdfByVersion = async (
  releaseVersion: string
): Promise<HttpResponse> => {
  const response = await instance.get(
    RELEASE_NOTES_PDF_BY_VERSION(releaseVersion),
    { responseType: 'blob' }
  )
  return response
}
